import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const InAppOpen = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M19.3201 9.18994V4.68994C19.3201 4.39157 19.2015 4.10542 18.9906 3.89445C18.7796 3.68347 18.4934 3.56494 18.1951 3.56494H4.69507C4.3967 3.56494 4.11055 3.68347 3.89957 3.89445C3.68859 4.10542 3.57007 4.39157 3.57007 4.68994V17.0649C3.57007 17.3633 3.68859 17.6495 3.89957 17.8604C4.11055 18.0714 4.3967 18.1899 4.69507 18.1899H9.19507"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4368 15.9375C20.4368 16.8275 20.1728 17.6975 19.6784 18.4376C19.1839 19.1776 18.4811 19.7544 17.6588 20.095C16.8366 20.4356 15.9318 20.5247 15.0589 20.351C14.1859 20.1774 13.3841 19.7488 12.7548 19.1195C12.1255 18.4901 11.6969 17.6883 11.5232 16.8154C11.3496 15.9425 11.4387 15.0377 11.7793 14.2154C12.1199 13.3932 12.6967 12.6904 13.4367 12.1959C14.1767 11.7014 15.0468 11.4375 15.9368 11.4375"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4368 12.5625L16.3342 16.6642C16.282 16.7165 16.22 16.758 16.1517 16.7863C16.0834 16.8146 16.0103 16.8291 15.9364 16.8291C15.8625 16.8291 15.7893 16.8146 15.721 16.7863C15.6528 16.758 15.5907 16.7165 15.5385 16.6642L14.25 15.375"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.57007 6.93994H19.3201"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
